import {Field} from './Field';

export type ResourceDetails = {
  id: string;
  __schema__?: OverrideSchema;
  [key: string]: any;
};

export type ResourceDetailsParams = {
  [key: string]: any;
};

export type OverrideSchema = {
  fields?: {[fieldId: string]: Field};
};

export function dummyResourceDetails(): ResourceDetails {
  return {id: 'dummy'};
}
